import React from 'react';
import { Dashboard } from './components/Dashboard';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <Dashboard data-id="element-1" /> again
    </div>;
}